import { useIntl } from 'react-intl';

/** Return a clean display name for a tool, filtering out hallucinated junk. */
export const useToolDisplayName = () => {
  const intl = useIntl();
  return (raw: string): string => {
    const key = `tool.${raw}`;
    if (intl.messages[key]) return intl.formatMessage({ id: key });
    // Also try with first character lowercased for PascalCase names (e.g. ListMaterials → listMaterials)
    const lowerFirstKey = `tool.${raw.charAt(0).toLowerCase()}${raw.slice(1)}`;
    if (lowerFirstKey !== key && intl.messages[lowerFirstKey]) return intl.formatMessage({ id: lowerFirstKey });
    if (!raw || raw.startsWith('$') || raw.startsWith('<') || raw.includes("'")) {
      return 'Tool';
    }
    // Fallback: split snake_case then PascalCase/camelCase
    return raw
      .split('_')
      .flatMap((word) => word.split(/(?<=[a-z])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/))
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
};
